import { session, appState, EP, THU_IMIE, API_BASE } from '../config.js';
import { fmt } from '../format.js';
import { ICONS, hydrateIcons, svg } from '../icons.js';
import { lineChart } from '../chart.js';
import { DEMO, demoDay } from '../demo.js';
import { apiGet, apiPost, apiPut, noData, imieFor } from '../api.js';
import { C, spinner, emptyRow, toast } from '../ui.js';
import { closeModal } from '../modal.js';
import { go } from '../router.js';
import { applyRole, canDelete } from '../auth.js';
import { toolBtns } from './operations.common.js';

export function viewPlant(plant){
  C().innerHTML=`<div class="page-title">Recycle Plant Processing Data — ${plant}</div>
  <div class="filterbar"><div class="field"><label>From Date</label><input type="date" id="fd"></div>
    <div class="field"><label>To Date</label><input type="date" id="td"></div>
    <button class="btn ghost" onclick="applyPlant('${plant}')">Apply</button></div>
  <div class="panel">
    <div class="panel-head"><h2>Processing Records</h2><div class="btns">${toolBtns()}</div></div>
    <div class="panel-body" style="padding:0"><table><thead><tr><th>Date</th><th>Total C&amp;D Processed Unit</th></tr></thead>
    <tbody id="plantBody">${emptyRow(2,'Choose a date range and tap Apply','calendar')}</tbody></table></div></div>`;
}

export async function applyPlant(plant){
  const fd=document.getElementById('fd').value,td=document.getElementById('td').value,body=document.getElementById('plantBody');
  if(!fd||!td){body.innerHTML=emptyRow(2,'Please select both From and To dates','alert');hydrateIcons(body);return}
  if(new Date(fd)>new Date(td)){body.innerHTML=emptyRow(2,'From date must be before To date','alert');hydrateIcons(body);return}
  body.innerHTML=`<tr><td colspan="2">${spinner}</td></tr>`;hydrateIcons(body);
  const toDMY=s=>{const[Y,M,D]=s.split('-');return `${D}-${M}-${Y}`};
  let rows=null;
  try{const r=await apiPost('PostApi.php',{ID:imieFor(plant),TableName:EP.plant},{FromDate:toDMY(fd),ToDate:toDMY(td)});const d=await r.json();if(Array.isArray(d))rows=d}catch(e){appState.OFFLINE=true;applyRole()}
  if(!rows){ // offline demo: every day 0.000
    rows=[];for(let dt=new Date(fd);dt<=new Date(td);dt.setDate(dt.getDate()+1)){rows.push({Date:`${String(dt.getDate()).padStart(2,'0')}-${String(dt.getMonth()+1).padStart(2,'0')}-${dt.getFullYear()}`,Weight:'0.000'})}
  }
  body.innerHTML=rows.map(x=>`<tr${x.Date==='Total Weight'?' style="font-weight:700;background:#f4efe3"':''}><td>${x.Date}</td><td class="num">${x.Weight}</td></tr>`).join('');
  toast('Filter applied');
}

/* ============================================================
   USERS  —  GetApi Logins / PostApi Logins / DeleteApi Logins
   ============================================================ */
